import { FC } from "react";
import { Footer as LunaFooter } from "@sainsburys-tech/luna-footer";
import { FlagComponent, FlagWrapper } from "@sainsburys-tech/luna-grid";
import { LinkButton } from "@sainsburys-tech/luna-button";

import "./Footer.scss";

const Footer: FC = () => {
  const links = ["Help Center", "Contact Us", "Terms and Conditions"];

  return (
    <>
      <LunaFooter>
        <FlagWrapper respondAt="sm" className="ln-u-caption">
          {/* <FlagBody className="ln-u-push-right-lg">
                            <span className="ln-u-display-block ln-u-font-weight-bold">
                                Sainsbury&rsquo;s, Helping everyone eat better
                            </span>
                            &copy; J Sainsbury plc {new Date().getFullYear()}
                        </FlagBody> */}
          <FlagComponent alignment="top">
            <div className="ln-u-display-flex ln-u-flex-wrap">
              {links.map((link, index) => (
                <span
                  className="ln-u-display-flex ln-u-align-items-center ln-u-text-align-center"
                  key={link}
                >
                  <LinkButton fullWidth bare className="footer-font-color">
                    {link}
                  </LinkButton>
                  {index !== links.length - 1 && (
                    <span className="ln-u-push-sides-sm"> </span>
                  )}
                </span>
              ))}
            </div>
          </FlagComponent>
        </FlagWrapper>
      </LunaFooter>
    </>
  );
};

export default Footer;
